module.exports = __webpack_public_path__ + "img/Phone2.eb888403.png";